import {
  Box,
  Button,
  createStyles,
  Group,
  Modal,
  Radio,
  Select,
  Text,
  TextInput,
} from "@mantine/core";

import React, { useEffect, useState } from "react";

import swal from "sweetalert";
import { UpdateBillingInvoicesStatus } from "../../../services/billinginvoice";
import { useSelector } from "react-redux";

const useStyles = createStyles(() => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      padding: "14px 18px 18px 18px",
      background: "rgb(245, 245, 245)",
    },
  },
  modalHeader: {
    padding: "13px 19px",
  },
  addbox: {
    padding: "35px 24px 47px 24px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    gap: "17px",
    "@media (max-width:1300px)": {
      // flexDirection: "column",
      // gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  formRowItem: {
    width: "100%",
  },
  itemLabel: {
    fontSize: "14px",
    lineHeight: "normal",
    fontWeight: 500,
    color: "#262626",
    marginBottom: "6px",
    fontFamily: "Inter",
  },
  selectnumber: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "8px",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'100%'
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  radiobox: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
  },

  datePicker: {
    width: "40%",
    "& .mantine-InputWrapper-label": {
      marginLeft: 10,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      background: "#FFF",
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
    },
  },

  itembox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    padding: "20px",
    width: "100%",
  },

  recurringbox: {
    marginTop: "24px",
    marginBottom: "24px",
    background: "#f2f2f2",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "center",
    gap: "72px",
    alignItems: "center",
    margin: "auto",
    padding: "6px 13px",
  },

  recuuringselect: {
    marginTop: "20px",
    marginBottom: "20px",
    justifyContent: "center",
    display: "flex",
  },
}));
const bgColor = "#D9D9D9";

const MarkAsPaid = ({ markasPaidOpen, setMarkAsPaidOpen, paymentdetials }) => {
  // State Hooks

  // Populate form when customer prop is available

  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const { classes } = useStyles();
  const onSave = async () => {
    setLoading(true);
    let payload = {
      admin: profile.user.id,
      invoiceid: paymentdetials.invoiceId,
    };

    console.log("payload", payload);

    const res = await UpdateBillingInvoicesStatus(payload);

    if (res.status === 200) {
      swal({
        title: `Invoice updated successfully`,
        text: "Invoice updated successfully",
        dangerMode: false,
        icon: "success",
      });

      setLoading(false);
      handleClose();
    }
  };
  const handleClose = () => {
    setMarkAsPaidOpen(false);
  };

  //   console.log('paymentdetials',paymentdetials);

  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <Box>
              {/* Title */}
              <Text fz={18} fw={700} style={{ marginBottom: "10px" }}>
                Payment Details
              </Text>

              <Text fz={20} fw={700} style={{ marginBottom: "10px" }}>
                The customer Paid this Invoice as{" "}
                {paymentdetials?.payment_Options.toUpperCase()}
              </Text>

              {/* Common details */}
              <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                <strong>Email:</strong> {paymentdetials?.email}
              </Text>
              <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                <strong>Name:</strong> {paymentdetials?.name}
              </Text>
              <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                <strong>Address:</strong> {paymentdetials?.address}
              </Text>
              <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                <strong>Phone:</strong> {paymentdetials?.phone}
              </Text>

              <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                <strong>PaymentType:</strong> {paymentdetials?.payment_Options}
              </Text>

              {/* Conditional rendering based on payment_Options */}
              {paymentdetials?.payment_Options === "cheque" ? (
                <Box>
                  <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                    <strong>Cheque Number:</strong>{" "}
                    {paymentdetials?.ChequeNo || "N/A"}
                  </Text>
                  <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                    <strong>Bank Name:</strong>{" "}
                    {paymentdetials?.BankName || "N/A"}
                  </Text>

                  <Text fz={16} fw={400} style={{ marginBottom: "8px" }}>
                    <strong>PaymentType:</strong>{" "}
                    {paymentdetials?.payment_Options}
                  </Text>
                </Box>
              ) : null}

              <Box
                style={{ marginTop: "40px", marginBottom: "0px" }}
                className={classes.formRow}
              >
                <Button
                  variant="filled"
                  onClick={handleClose}
                  c={"#000"}
                  radius={"8px"}
                  className={classes.formRowItem}
                  style={{
                    background: "#F5F5F5",
                    height: "fit-content",
                    padding: "16px",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                  size="md"
                >
                  Cancel
                </Button>

                <Button
                  onClick={onSave}
                  loading={loading}
                  variant="filled"
                  className={classes.formRowItem}
                  c={"#000"}
                  radius={"8px"}
                  size="md"
                  style={{
                    height: "fit-content",
                    padding: "16px",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                  color="yellow"
                  // loading={loading}
                >
                  Confirm Payment
                </Button>
              </Box>
            </Box>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Modal
      centered
      size={1000}
      shadow="md"
      radius={"lg"}
      zIndex={1000}
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      style={{ background: "#F5F5F5" }}
      opened={markasPaidOpen}
      classNames={{ header: classes.modalHeader }}
      className={classes.modalBody}
      title={
        <Text fz={"24px"} ff={"Inter"} fw={700}>
          Customer Payment Details
        </Text>
      }
    >
      <Box>{renderContent()}</Box>
    </Modal>
  );
};

export default MarkAsPaid;
